import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { TranslocoModule } from '@jsverse/transloco';
import { ComponentLibraryModule } from '@libraries/component-library';
import { FaIconModule } from '@libraries/fa';
import { GoogleMapsAddressModule } from '@libraries/google-maps';
import { UiModule } from '@libraries/ui';
import { UiStateModule } from '@libraries/ui-state';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ImageDataResolver } from '../guards/imageData.resolver';
import { AddressesComponent } from './addresses/addresses.component';
import { CalculateExistingImprovementMonthlyCostComponent } from './calculate-existing-improvement-monthly-cost/calculate-existing-improvement-monthly-cost.component';
import { CalculateOtherImprovementMonthlyCostComponent } from './calculate-other-improvement-monthly-cost/calculate-other-improvement-monthly-cost.component';
import { ComingSoonSuccessComponent } from './coming-soon-success/coming-soon-success.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { CongratulationsWaitlistComponent } from './congratulations-waitlist/congratulations-waitlist.component';
import { HeaderWrapperComponent } from './header-wrapper/header-wrapper.component';
import { MayBeEligibleComponent } from './may-be-eligible/may-be-eligible.component';
import { PrequalQuestionsRoutingModule } from './prequal-questions-routing.module';
import { QuestionsComponent } from './questions/questions.component';
import { SuccessComponent } from './success/success.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollingModule,
    PrequalQuestionsRoutingModule,
    FaIconModule,
    ComponentLibraryModule,
    UiModule,
    UiStateModule,
    MatButtonModule,
    MatInputModule,
    MatRadioModule,
    MatCardModule,
    MatCheckboxModule,
    TranslocoModule,
    NgxMaskDirective,
    NgxMaskPipe,
    GoogleMapsAddressModule,
  ],
  declarations: [
    QuestionsComponent,
    AddressesComponent,
    ComingSoonComponent,
    ComingSoonSuccessComponent,
    SuccessComponent,
    HeaderWrapperComponent,
    MayBeEligibleComponent,
    CalculateOtherImprovementMonthlyCostComponent,
    CalculateExistingImprovementMonthlyCostComponent,
    CongratulationsWaitlistComponent,
  ],
  providers: [ImageDataResolver, provideNgxMask(), provideHttpClient(withInterceptorsFromDi())],
})
export class PrequalQuestionsModule {}
